import Demo from './Demo.tsx';

import './App.css';
import './index.css';

function App() {
  return (
    <div className="App">
      <Demo />
    </div>
  );
}

export default App;
